// 保存打开的第一个落地页url给到attributes[landing_site_url]订单的
(function () {
  if (window.__landingSiteAttrInit) return;
  window.__landingSiteAttrInit = true;

  var LANDING_KEY = 'landing_site_url';
  var INPUT_SELECTOR = 'input[name="attributes[landing_site_url]"]';
  var cachedLandingUrl = null;

  function safeGetStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSetStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function getLandingSiteUrl() {
    if (cachedLandingUrl) return cachedLandingUrl;
    var current = window.location.href || '';
    var stored = safeGetStorage(LANDING_KEY);
    if (!stored) {
      safeSetStorage(LANDING_KEY, current);
      stored = current;
    }
    cachedLandingUrl = stored || current;
    return cachedLandingUrl;
  }

  function syncLandingInputs(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var value = getLandingSiteUrl();
    var fields = root.querySelectorAll(INPUT_SELECTOR);
    if (!fields.length) return;
    fields.forEach(function (field) {
      if (field.value !== value) field.value = value;
    });
  }

  function bindFormSubmitSync() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.querySelector) return;
        var field = form.querySelector(INPUT_SELECTOR);
        if (!field) return;
        field.value = getLandingSiteUrl();
      },
      true
    );
  }

  syncLandingInputs(document);
  bindFormSubmitSync();
  document.addEventListener('DOMContentLoaded', function () {
    syncLandingInputs(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    syncLandingInputs(e.target || document);
  });
})();


// 详情页立即购买按钮跳转到变体选择模块
(function () {
    if (window.__wnowAnchorScrollBound) return;
    window.__wnowAnchorScrollBound = true;
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest('.wnow-btn[data-wnow-anchor="true"]');
        if (!a) return;
        var id = (a.getAttribute('data-wnow-target') || '').replace('#', '').trim();
        if (!id) {
          var href = a.getAttribute('href') || '';
          var hashIndex = href.indexOf('#');
          if (hashIndex >= 0) {
            id = href.slice(hashIndex + 1);
          }
        }
        if (!id) return;
        var el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      },
      false
    );
  })();



// #MainContent：设计宽固定 1920px；视口 ≥768 时用 zoom=视口/1920；<768 清空样式恢复手机端
(function () {
  var DESIGN_WIDTH = 1920;
  var MOBILE_MAX = 767;
  var rafId = null;

  function applyMainContentZoom() {
    var el = document.getElementById('MainContent');
    if (!el) return;

    var vw = document.documentElement.clientWidth || window.innerWidth;
    if (vw <= 0) return;

    if (vw <= MOBILE_MAX) {
      el.style.zoom = '';
      return;
    }

    var z = vw / DESIGN_WIDTH;
    // el.style.width = DESIGN_WIDTH + 'px';
    // el.style.maxWidth = 'none';
    el.style.zoom = z;
  }

  function scheduleApply() {
    if (rafId != null) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      applyMainContentZoom();
    });
  }

  window.addEventListener('resize', scheduleApply, { passive: true });
  document.addEventListener('DOMContentLoaded', applyMainContentZoom);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    applyMainContentZoom();
  }
})();


// 数字动画：.animation-number 内为最终数字（可含千分位），进入视口后从 0 计数到目标
(function () {
  if (window.__animationNumberInit) return;
  window.__animationNumberInit = true;

  function digitsFromText(el) {
    var raw = (el.textContent || '').replace(/[^\d]/g, '');
    var n = parseInt(raw, 10);
    return isNaN(n) || n < 0 ? 0 : n;
  }

  function formatInt(n) {
    return Math.round(n).toLocaleString();
  }

  function animateOne(el) {
    if (el.getAttribute('data-count-done') === '1') return;
    var target = digitsFromText(el);
    if (target <= 0) return;

    var duration = 2200;
    var startTs = null;
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }
    function frame(ts) {
      if (startTs == null) startTs = ts;
      var p = Math.min(1, (ts - startTs) / duration);
      var eased = easeOutCubic(p);
      el.textContent = formatInt(eased * target);
      if (p < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = formatInt(target);
        el.setAttribute('data-count-done', '1');
      }
    }
    el.textContent = formatInt(0);
    requestAnimationFrame(frame);
  }

  function bind() {
    var nodes = document.querySelectorAll('.animation-number');
    if (!nodes.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            animateOne(entry.target);
          });
        },
        { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
      );
      nodes.forEach(function (n) {
        io.observe(n);
      });
    } else {
      nodes.forEach(animateOne);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();


// 全局计算立即购买按钮折扣（支持动态渲染/区块刷新）
(function () {
  if (window.__wnowDiscountInit) return;
  window.__wnowDiscountInit = true;

  function toNumber(val) {
    if (val == null) return 0;
    var normalized = String(val).replace(/[^0-9.\-]/g, '');
    var n = parseFloat(normalized);
    return isNaN(n) ? 0 : n;
  }

  function applyDiscountForButtonRoot(root) {
    if (!root || root.nodeType !== 1) return;
    var price = toNumber(root.getAttribute('data-wnow-price'));
    var compareAtPrice = toNumber(root.getAttribute('data-wnow-compare-at-price'));
    if (!price || !compareAtPrice || compareAtPrice <= price) return;

    var discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
    if (!discount || discount < 1) return;

    root.querySelectorAll('.btn-discount').forEach(function (discountEl) {
      discountEl.textContent = discount + '%';
    });
  }

  function applyDiscounts(scope) {
    var roots;
    if (scope && scope.matches && scope.matches('.wnow-buttons')) {
      roots = [scope];
    } else if (scope && scope.querySelectorAll) {
      roots = scope.querySelectorAll('.wnow-buttons');
    } else {
      roots = document.querySelectorAll('.wnow-buttons');
    }
    if (!roots || !roots.length) return;
    roots.forEach(applyDiscountForButtonRoot);
  }

  function init() {
    applyDiscounts(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function (e) {
    applyDiscounts(e.target || document);
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    applyDiscounts(e.target || document);
  });

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (!m.addedNodes || !m.addedNodes.length) return;
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        applyDiscounts(node);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


